import {getItemName} from "../../../shared/utils/basic";
import dayjs from "dayjs";
import {Sorter} from "../../../shared/components/Sorter";
import {Tag} from "antd";
import React from "react";
import {MAIL_TYPE} from "../../../shared/utils/enum";
import {getMailTypeColorAndText} from "../../../shared/utils/typeChecks";

export const getMailLogColumns = (krTextData, currentUser) => {
    return [
        {
            title: '우편 IDX',
            dataIndex: 'id',
            search: true,
        },
        {
            title: '아이템 Type',
            dataIndex: 'itemType',
        },
        {
            title: '아이템 ID',
            dataIndex: 'itemId',
            search: true
        },
        {
            title: '아이템 이름',
            dataIndex: 'itemId',
            render: (_, {
                itemId,
                itemType,
                productId
            }) => getItemName(krTextData[currentUser.target], itemId, itemType, productId)
        },
        {
            title: '아이템 갯수',
            dataIndex: 'quantity',
        },
        {
            title: '발송 날짜',
            dataIndex: 'created',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.time, b.time),
        },
        {
            title: '삭제 날짜',
            dataIndex: 'deleted',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.time, b.time),
        },
        {
            title: '상태',
            dataIndex: 'deleteType',
            render: (_, {deleteType}) => (
                <Tag color={deleteType ? 'red' : 'green'}>
                    {deleteType ? '기간 만료' : '수신 완료'}
                </Tag>
            ),
            filters: [
                {
                    text: '기간 만료',
                    value: 1,
                },
                {
                    text: '수신 완료',
                    value: 0,
                },
            ],
            onFilter: (value, record) => record.deleteType === value,
        },
        {
            title: '사유',
            dataIndex: 'mailType',
            width: 80,
            render: (_, {mailType}) => {
                const {color, text} = getMailTypeColorAndText(mailType);
                return <Tag color={color}>{text}</Tag>;
            }
        }
    ]
};